export function NotIncludedBadge() {
  return (
    <div className="rounded-full border border-orange-500/30 bg-orange-500/10 px-2 py-0.5 text-[10px] font-medium text-orange-500">
      Not Included
    </div>
  );
}
